import Axios from 'axios';

import {
	APP_CONFIG_GET,
	APP_CONFIG_ERROR
} from '../types';

export const get_app_config = () => dispatch => {
	const url = `${process.env.REACT_APP_SERVER_URL}/api/apps/screens/data?app=${process.env.REACT_APP_ALIAS}`;

	Axios.get(url)
	.then((res) => {
		dispatch({
			type: APP_CONFIG_GET,
			payload: res.data
		});
	}).catch((err) => {
		dispatch({
			type: APP_CONFIG_ERROR,
			payload: { type: 'app_config', msg: err.message }
		});
	});
}
